export default "__VITE_ASSET__Crko1gQm__"